import { createAsyncThunk } from '@reduxjs/toolkit';
import ApiaApi from '../../../api/apiaApi/apiaApi';
import { notify } from '../../../components/common/notifications/util';
import { makeGridActionUrl } from '../actionsUtils';
import { TApiaXMLResponse, TDataGridThunkState } from '../types';
import { shouldDebugGridActions } from './add';
import { TRowActionResponse } from './types';
import EventEmitter from '../../../utils/util/eventEmitter';

export const dataGridRefreshEvent =
  new (class DataGridRefreshEvent extends EventEmitter<{
    refresh: {
      gridId: string;
      data: TApiaXMLResponse;
    };
  }> {})();

const refresh = createAsyncThunk<
  TRowActionResponse | null,
  {
    gridId: string;
    fromEditionForm?: boolean;
  },
  TDataGridThunkState
>('dataGridSlice/refresh', async ({ fromEditionForm, gridId }, thunkApi) => {
  const state = thunkApi.getState().dataGridSlice[gridId];
  const result = await ApiaApi.post<TApiaXMLResponse>(
    makeGridActionUrl({
      gridAction: 'refresh',
      context: state.context,
      page: state.context.grid.field.curPage,
    }),
  );
  if (shouldDebugGridActions) console.log('refresh', result?.data);
  if (result?.data) {
    dataGridRefreshEvent.emit('refresh', {
      gridId,
      data: result.data,
    });
    return {
      focusGrid: false,
      focusRow: state.focusedRow,
      newSelectedRows: state.selectedRows,
      xmlResponse: result?.data,
      fromEditionForm,
    };
  }

  notify({
    message: 'Error on DataGrid action',
    type: 'danger',
  });
  return null;
});

export default refresh;
